import React from 'react'
import { FC } from 'react'
import { Popup } from 'react-leaflet'
import { VehiclePosition } from '../types'
import {
  Label,
  Row,
  Value,
  Title,
  Container,
  Table,
  LastKnownLocationBanner,
} from './MapPopup.styles'
import './MapPopup.style.css'

interface PopupProps {
  vehicle: VehiclePosition
}

const MapPopup: FC<PopupProps> = ({ vehicle }) => {
  return (
    <Popup className={vehicle.isLastKnownPosition ? 'last-known-location' : ''}>
      <Container>
        <Title>{`Voertuig ${vehicle.vehicleId}`}</Title>
        {vehicle.isLastKnownPosition && (
          <LastKnownLocationBanner>
            Laatst gekende locatie!
          </LastKnownLocationBanner>
        )}
        <Table>
          <Row>
            <Label>Positie:</Label>
            <Value>{vehicle.lat}</Value>
          </Row>
          <Row>
            <Value />
            <Value>{vehicle.lon}</Value>
          </Row>
          <Row>
            <Label></Label>
          </Row>
          <Row>
            <Label>Rit:</Label>
            <Value>{vehicle.tripId}</Value>
          </Row>
          <Row>
            <Label>Block:</Label>
            <Value>{vehicle.blockId}</Value>
          </Row>
          <Row>
            <Label></Label>
          </Row>
          <Row>
            <Label>Line:</Label>
            <Value>{vehicle.lineId}</Value>
          </Row>
          <Row>
            <Label>Stop:</Label>
            <Value>{vehicle.stopId}</Value>
          </Row>
          <Row />
          <Row>
            <Label>Stop Sequence Number:</Label>
            <Value>{vehicle.stopSequenceNumber}</Value>
          </Row>
          <Row>
            <Label>Previous Stop:</Label>
            <Value>{vehicle.previousStopId}</Value>
          </Row>
          <Row>
            <Label>Previous Stop Sequence Number:</Label>
            <Value>{vehicle.previousStopSequenceNumber}</Value>
          </Row>
          <Row>
            <Label>Previous Stop Arrival:</Label>
            <Value>{vehicle.previousStopArrival}</Value>
          </Row>
          <Row>
            <Label>Previous Stop Departure:</Label>
            <Value>{vehicle.previousStopDeparture}</Value>
          </Row>
          <Row>
            <Label>Updated:</Label>
            <Value>
              {vehicle.updateEpochMillis
                ? new Date(vehicle.updateEpochMillis).toLocaleString()
                : 'N/A'}
            </Value>
          </Row>
          <Row>
            <Label>Event Created:</Label>
            <Value>
              {vehicle.eventCreatedEpochMillis
                ? new Date(vehicle.eventCreatedEpochMillis).toLocaleString()
                : 'N/A'}
            </Value>
          </Row>
          <Row>
            <Label>State:</Label>
            <Value>{vehicle.event}</Value>
          </Row>
          <Row>
            <Label>Speed:</Label>
            <Value>
              {vehicle.speed !== undefined
                ? Math.round(vehicle.speed * 3.6) + 'km/h'
                : 'N/A'}
            </Value>
          </Row>
          <Row>
            <Label>Delay:</Label>
            <Value>{vehicle.delay}s</Value>
          </Row>
          <Row>
            <Label>On Track:</Label>
            <Value>{vehicle.onTrack ? 'yes' : 'no'}</Value>
          </Row>
        </Table>
      </Container>
    </Popup>
  )
}
export default MapPopup
